export default "__VITE_ASSET__1g8tS$1p__"